import React, { FC } from 'react';

const EntityImage: FC<{ val: string; width: number; height: number }> = ({ val, width, height }) =>
  val ? (
    <img src={val} style={{ borderRadius: '100%', width, height }} alt="Картинка для отображения" />
  ) : (
    <>Изображение не задано</>
  );

export default EntityImage;
